import { render, staticRenderFns } from "./HomeViewVideoCenter.vue?vue&type=template&id=17547b09&"
import script from "./HomeViewVideoCenter.vue?vue&type=script&lang=js&"
export * from "./HomeViewVideoCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports